var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page3-container" },
    [
      !_vm.isMobile()
        ? _c("Step2Desktop", {
            on: {
              leavebuilder: _vm.leaveBuilder,
              changepage: function($event) {
                return _vm.changePage($event)
              },
              gostep: function($event) {
                return _vm.goStep($event)
              }
            }
          })
        : _c("Step2Mobile", {
            on: {
              leavebuilder: _vm.leaveBuilder,
              changepage: function($event) {
                return _vm.changePage($event)
              }
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }